import { UserAttribute } from 'frontend/core/src/graphqlTypes/enums';

export function isDeploymentUXEnabled(user: { attributes: string[] }) {
  return user.attributes.includes(UserAttribute.DeploymentAttr);
}
